import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const PascoeValeSouthPage = () => (
  <LocationTemplate suburbName="Pascoe Vale South" suburbSlug="pascoe-vale-south" />
);

export default PascoeValeSouthPage;
